import React from 'react';
import { NavMenu } from './NavMenu';
import { ToastContainer } from 'react-toastify';
import ClockInModal from './ClockInModal';
import Base from './Base';

export class Layout extends Base {
    constructor(props) {
        super(props);
        this.state = {
            showClockIn: false,
            clockedIn: false,
            clockInTime: null,
        };
    }

    componentDidMount() {
        // فقط در صورتی که کاربر لاگین کرده باشد (مسیر login نیست) چک می‌کنیم
        if (!window.location.href.includes("/login")) {
            this.checkAttendance();
        }
    }

    checkAttendance = () => {
        this.httpPost('api/v1/attendance/todayStatus', {})
            .then(res => {
                if (res.status === 1) {
                    if (!res.clockedIn) {
                        this.setState({ showClockIn: true });
                    } else {
                        this.setState({
                            clockedIn: true,
                            clockInTime: res.clockInTime ? new Date(res.clockInTime) : null,
                        });
                    }
                }
                // در صورت خطا (مثلاً session منقضی) کاری نمی‌کنیم – کاربر به login هدایت می‌شود
            })
            .catch(() => { });
    };

    handleClockInDone = (clockInTime) => {
        // بعد از ثبت موفق ورود، مودال بسته شده و نیازی به reload نیست.
        // اگر Header مستقیماً در Layout رندر نشده باشد، می‌توانیم با یک forceUpdate یا کلید،
        // ولی برای سادگی صفحه را reload می‌کنیم تا هدر هم بروز شود.
        window.location.reload();
    };

    render() {
        const isLoginPage = window.location.href.includes("/login");

        return (
            <>
                {/* مودال ورود اجباری – بیرون از nk-main برای z-index بهتر */}
                {this.state.showClockIn && !isLoginPage && (
                    <ClockInModal onClockedIn={this.handleClockInDone} />
                )}

                {isLoginPage ? (
                    <div className="nk-main ">
                        <div className="nk-wrap nk-wrap-nosidebar">
                            <ToastContainer
                                position="top-center"
                                autoClose={2500}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={true}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                theme="dark"
                            />
                            {this.props.children}
                        </div>
                    </div>
                ) : (
                    <div className="nk-main ">
                        <ToastContainer
                            position="top-center"
                            autoClose={2500}
                            hideProgressBar={false}
                            newestOnTop={false}
                            closeOnClick
                            rtl={true}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                            theme="dark"
                        />
                        <NavMenu />
                        <div className="nk-wrap">
                            {this.props.children}
                        </div>
                    </div>
                )}
            </>
        );
    }
}